import React from 'react';
import { Sparkles } from 'lucide-react';

interface LogoProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
}

export default function Logo({ size = 'md', className = '', onClick, ...props }: LogoProps) {
  const sizes = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  return (
    <div 
      className={`inline-flex items-center whitespace-nowrap ${className} ${onClick ? 'cursor-pointer hover:opacity-80' : ''}`}
      onClick={onClick}
      {...props}
    >
      <div className="relative">
        <div className="relative">
          <Sparkles className={`${sizes[size]} text-indigo-600 animate-pulse`} />
          <div className="absolute -inset-1 bg-gradient-to-r from-indigo-600/20 to-purple-600/20 rounded-lg -z-10 blur-lg" />
        </div>
      </div>
      <span className={`ml-2 font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent ${
        size === 'lg' ? 'text-3xl' : size === 'md' ? 'text-xl' : 'text-lg'
      }`}>PM Pro AI</span>
    </div>
  );
}